import React, { useEffect, useState } from "react";
import ChevronDown from "@wantable/Shared/src/components/Icons/ChevronDown";
import HelpDropdown from "./HelpDropdown";
import useDropdownVisible from "../../hooks/useDropdownVisible";

interface IHelpProps {
  isLoggedIn: boolean;
  className?: string;
}

const Help = ({ isLoggedIn, className }: IHelpProps) => {
  const { ref, isDropdownVisible, setIsDropdownVisible } = useDropdownVisible(false);
  const [chatLoaded, setChatLoaded] = useState<boolean>(false)
  const chatElem = document.querySelectorAll("[data-testid='launcher'")

  useEffect(() => {
    if (chatElem) {
      setChatLoaded(true)
    }
  }, [chatLoaded])


  return (
    <div ref={ref} role="button"
    onClick={(event) => {
      event.stopPropagation();
      setIsDropdownVisible((prevState) => !prevState)
    }}
    aria-expanded={isDropdownVisible}
    className="relative flex justify-center items-center ml-30">Need Help?
      <ChevronDown />
      {isDropdownVisible &&
        <HelpDropdown
          isLoggedIn={isLoggedIn}
          chatLoaded={chatLoaded}
        />
      }
    </div>
  );
};

export default Help;
